import React, { useEffect, useState } from "react";
import { Button, Dimmer, Loader } from "semantic-ui-react";

import useApiService from "../../../../../services/useApiService";
import SemanticUiModal from "../../../../../components/modal";
import ControlTranslationIdLabel from "../../../../../components/control_translation_id_label";
import EditTranslationModalContent from "./edit_translation_modal_content";

const modalOptions = { className: "full-height-modal", size: "medium" };

export default function EditTranslationModal(props) {
  const { newTranslation, onClose } = props;
  const { control, language, currentLanguage } = newTranslation;
  const [editedTranslation, setEditedTranslation] = useState({});
  
  const translation_id = control["translations"][language.value.toLowerCase()].id;

  const [{ isLoading: isLoadingTranslation, response: translation }] = useApiService({
    url: `/library_control_translations/${translation_id}`,
    onMount: true,
    onSuccess(response) {
      setEditedTranslation({
        ...response.translation_result,
        notes: response.notes,
        tag_list: response.tag_list
      })
    },
  });

  const [{ isLoading }, translateControl] = useApiService({
    url: "/library_controls/translate",
    method: "post",
    onSuccess: onClose,
  });

  function onSave() {
    const translation_source = {
      title: control.title,
      subtitle: control.subtitle,
      description: control.description,
      language: "English",
    };

    const translation_result = {
      title: editedTranslation.title,
      subtitle: editedTranslation.subtitle,
      description: editedTranslation.description,
      language: language.value,
    };

    translateControl({
      library_control_id: control.id,
      translation_type: "manual",
      translation_source,
      translation_result,
      notes: editedTranslation.notes,
      tag_list: editedTranslation.tag_list
    });
  }

  function onTranslationChange(event) {
    const { name, value } = event.target;
    setEditedTranslation({
      ...editedTranslation,
      [name]: value,
    });
  }

  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={
        <span>
          Edit Translation&nbsp;
          <ControlTranslationIdLabel translation={translation} />
        </span>
      }
      content={
        isLoadingTranslation ? (
          <div className="position-relative">
            <Dimmer active inverted>
              <Loader inverted />
            </Dimmer>
          </div>
        ) : (
          <EditTranslationModalContent
            control={control}
            language={language}
            currentLanguage={currentLanguage}
            translation={translation}
            editedTranslation={editedTranslation}
            onTranslationChange={onTranslationChange}
          />
        )
      }
      actions={
        <div>
          <Button onClick={onClose} disabled={isLoading}>
            Close
          </Button>
          <Button positive size="medium" onClick={onSave} disabled={isLoading}>
            Save
          </Button>
        </div>
      }
      closeModal={onClose}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/edit_translation_modal/edit_translation_modal.js